<template lang="pug">
.caroucel-background
    v-container.footer-container 
        div(style="display: inline") © 2020 Ticketeer 
        div.ml-5(style="display: inline") 5eraph@github.com
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";

import VueTinySlider from './slider';

export default {
  name: "Caroucel",

  data: () => ({  }),
  components: {
    Carousel3d,
    Slide,
    'tiny-slider': VueTinySlider
  }
};
</script>

<style lang="stylus" scoped>
.footer-container {
    color: white;

  text-align: center;
}

.caroucel-background {
  background-color: #444444;
}

</style>
